module.exports = __webpack_public_path__ + "static/media/lombardia__erwin_riveiro.a1bcd2c0.jpg";